/**
 * Flag names shared across layers, so a flag read in more than one place is
 * spelled once.
 *
 * `useFeatureFlag` takes any string and a miss reads as "off", so a typo hides
 * a feature silently rather than failing — unlike pantheon, which checks the
 * literal against its registry at compile time.
 */
export const COPYLEAKS_FLAG = "copyleaks";
